// import { createClient } from "contentful"

// export const client = createClient({
//   space: "5js33qa91bb1",
//   accessToken: "PdbvtK53PyRpfRPF-bUTAERkiPaSCpMKWzoY28H_Mcw"
// })

import { createClient } from 'contentful';

const client = createClient({
  //space: '5js33qa91bb1',                    // Your Space ID
  space: 'oy3fk129q43c',                    // Your Space ID
  //accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN, // Add this to .env.local
  //accessToken: 'PdbvtK53PyRpfRPF-bUTAERkiPaSCpMKWzoY28H_Mcw', // Add this to .env.local
  accessToken: 'x44Dk26Ui6U0NY46xuypVldLIDe2KCXmKtz-gmYiZP8', // Add this to .env.local
  environment: 'master',
});

export async function getTeamMembers() {
  const response = await client.getEntries({
    content_type: 'person',
    include: 2,                       // Resolves the image asset
    order: ['fields.category', 'fields.name'], // Optional: sort by category then name
  });

  return response.items.map((item) => {
    const fields = item.fields;
    const imageAsset = fields.image?.fields?.file?.url 
      ? `https:${fields.image.fields.file.url}` 
      : null;

    return {
      id: item.sys.id,
      name: fields.name || '',
      role: fields.role || '',
      bio: fields.bio || '',
      index: fields.index || 0,
      image: imageAsset,
      social: {
        linkedin: fields.linkedin || '',
        // Add twitter/email later if you extend the content model
      },
      category: fields.category || 'other', // e.g., "board", "advisors", "leadership", "senior"
    };
  });
}

export async function getCourses() {

  const response = await client.getEntries({
    content_type: "course",
    order: ["fields.title"]
  })

  return response.items.map((item) => {

    const fields = item.fields

    return {
      id: item.sys.id,

      slug: fields.slug || "",

      title: fields.title || "",

      overview: fields.overview || "",

      fullOverview: fields.fullOverview || [],

      learningOutcomes: fields.learningOutcomes || [],

      modules: fields.modules || [],

      about: fields.about || "",

      requirements: fields.requirements || "",

      duration: fields.duration || "",

      modes: fields.modes || "",

      certificate: fields.certificate || "",

      fee: fields.fee || "",

      studentFee: fields.studentFee || "",

      targetAudience: fields.targetAudience || "",

      convener: fields.convener || ""
    }

  })
}


export async function getCourseBySlug(slug) {

  const response = await client.getEntries({
    content_type: "course",
    "fields.slug": slug,
    limit: 1
  })

  const item = response.items[0]

  if (!item) return null

  const fields = item.fields

  return {
    id: item.sys.id,
    slug: fields.slug,
    title: fields.title,
    overview: fields.overview,
    fullOverview: fields.fullOverview || [],
    learningOutcomes: fields.learningOutcomes || [],
    modules: fields.modules || [],
    about: fields.about,
    requirements: fields.requirements,
    duration: fields.duration,
    modes: fields.modes,
    certificate: fields.certificate,
    fee: fields.fee,
    studentFee: fields.studentFee,
    targetAudience: fields.targetAudience,
    convener: fields.convener
  }
}